import { Spinner, VStack } from '@chakra-ui/react';
import { Permission } from '@common/permissions';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { usePermissions, useSession } from 'src/apps/invest/common/hooks';
import { useStatementViewModel } from '../models/StatementViewModel';
import { StatementPage } from '../views/StatementPage';

const sessionRedirect = window.location.pathname;
const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

export const StatementController: React.FC = () => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();
  const { month } = useParams();
  const statementViewModel = useStatementViewModel();

  async function init() {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;

    if (month) {
      await statementViewModel.init(month);
    }
  }

  useEffect(() => {
    init();
  }, []);

  return statementViewModel.isLoading ? (
    <VStack height="100%" justifyContent={'center'} backgroundColor="transparent">
      <Spinner size="lg" color="blue.500" />
    </VStack>
  ) : (
    <StatementPage />
  );
};
